/* assets/kbs-alma.js */
(() => {
  if (window.__kbsAlmaLoaded) return;
  window.__kbsAlmaLoaded = true;

  const API = 'https://api.getalma.eu/v2/payments/eligibility';
  const SDK_JS = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.umd.js';
  const SDK_CSS = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.min.css';
  const SDK_LOCALES = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt'];
  const MODAL_BTNS = '#alma-widget-modal-main-container .alma-eligibility-modal-eligibility-options button';
  const TTL = 3600000;

  let sdk = null;
  function loadSdk() {
    if (sdk) return sdk;
    sdk = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = SDK_CSS;
      document.head.appendChild(css);
      const js = document.createElement('script');
      js.src = SDK_JS;
      js.onload = resolve;
      js.onerror = reject;
      document.head.appendChild(js);
    });
    return sdk;
  }

  async function eligibility(merchant, amount, country) {
    const key = 'kbs-alma:' + merchant + ':' + country + ':' + amount;
    try {
      const hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && Date.now() - hit.t < TTL) return hit.v;
    } catch (e) { /* privater Modus */ }

    const res = await fetch(API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Alma-Merchant-Auth ' + merchant,
        'X-Alma-Agent': 'KBS Widget/1.0'
      },
      body: JSON.stringify({ purchase_amount: amount, billing_address: { country } })
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (!Array.isArray(data)) return null;
    const v = data.filter((p) => p.eligible && Array.isArray(p.payment_plan));
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v })); } catch (e) {}
    return v;
  }

  class KbsAlma {
    constructor(root) {
      this.root = root;
      this.chips = root.querySelector('[data-kbs-alma-chips]');
      this.info = root.querySelector('[data-kbs-alma-info]');
        this.more = root.querySelector('[data-kbs-alma-more]');
      this.quick = root.dataset.quick === 'true';
      this.modalPlan = null;
      this.modalObs = null;
      this.merchant = root.dataset.merchant;
      this.country = root.dataset.country;
      this.currency = root.dataset.currency || 'EUR';
      this.format = root.dataset.moneyFormat || '';
      this.modal = root.dataset.modal === 'true';
      this.rotate = root.dataset.rotate === 'true';
      this.rotateDelay = parseInt(root.dataset.rotateDelay, 10) || 4000;
      this.payNow = root.dataset.payNow === 'true';
      this.allowed = (root.dataset.plans || '')
        .split(',')
        .map((n) => parseInt(n, 10))
        .filter((n) => n > 1);
      this.twoTap = root.dataset.tap !== 'one';
      this.wanted = parseInt(root.dataset.defaultPlan, 10) || 3;
      this.t = {
        payNow: root.dataset.tPayNow,
        payNowAmount: root.dataset.tPayNowAmount,
        same: root.dataset.tSame,
        split: root.dataset.tSplit,
        splitOne: root.dataset.tSplitOne,
        buy: root.dataset.tBuy,
        noFee: root.dataset.tNoFee,
        credit: root.dataset.tCredit,
        cost: root.dataset.tCost,
        ariaPlan: root.dataset.tAriaPlan
      };
      this.plans = [];
      this.index = 0;
      this.locked = false;
      this.timer = null;
      this.debounce = null;

      try {
        this.variants = JSON.parse(root.querySelector('[data-kbs-alma-variants]').textContent);
      } catch (e) {
        this.variants = {};
      }
      this.basePrice = parseInt(root.dataset.price, 10) || 0;

      if (window.Shopify && Shopify.currency && Shopify.currency.active !== this.currency) {
        root.hidden = true;
        return;
      }

      this.bind();
      this.refresh();
    }

    money(cents) {
      const value = cents / 100;
      if (!/\{\{/.test(this.format)) {
        return value.toLocaleString(undefined, { style: 'currency', currency: this.currency });
      }
      const comma = /comma_separator/.test(this.format);
      const apos = /apostrophe_separator/.test(this.format);
      const plain = /no_decimals/.test(this.format);
      const parts = (plain ? Math.round(value).toString() : value.toFixed(2)).split('.');
      const group = apos ? "'" : comma ? '.' : ',';
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
      const out = parts[0] + (parts[1] ? (comma ? ',' : '.') + parts[1] : '');
      return this.format.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    label(plan) {
      if (plan.installments_count === 1) {
        if (plan.deferred_days) return 'T+' + plan.deferred_days;
        if (plan.deferred_months) return 'M+' + plan.deferred_months;
        return this.t.payNow;
      }
      return plan.installments_count + 'x';
    }

    percent(bps) {
      const locale = (this.root.dataset.locale || 'de').replace('_', '-');
      let n;
      try {
        n = (bps / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        n = (bps / 100).toFixed(2);
      }
      return n + '\u00a0%';
    }

    line(plan) {
      const s = plan.payment_plan;
      if (!s || !s.length) return '';

      const first = s[0].total_amount;

      if (plan.installments_count === 1) {
        return this.t.payNowAmount.replace('%A%', this.money(first));
      }
      const tail = plan.installments_count - 1;
      const tpl = tail === 1 && this.t.splitOne ? this.t.splitOne : this.t.split;
      return tpl
        .replace('%F%', this.money(first))
        .replace('%C%', tail)
        .replace('%R%', this.money(s[1].total_amount));
    }

    amount() {
      const form = document.querySelector('form[action*="/cart/add"]');
      const id =
        new URLSearchParams(location.search).get('variant') ||
        (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
      const price = (id && this.variants[id]) || this.basePrice;
      const qtyEl = form && form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      return price * qty;
    }

    async refresh() {
      const amount = this.amount();
      if (!amount) { this.root.hidden = true; return; }
      this.current = amount;
      this.root.classList.add('kbs-alma--busy');

      let plans = null;
      try {
        plans = await eligibility(this.merchant, amount, this.country);
      } catch (e) { /* Netzwerk: Liquid-Vorschau bleibt stehen */ }

      this.root.classList.remove('kbs-alma--busy');
      if (!plans) return;

      this.plans = plans.filter((p) => {
        if (p.deferred_days || p.deferred_months) return false;
        if (p.installments_count > 1) return this.allowed.indexOf(p.installments_count) !== -1;
        return this.payNow;
      });

      if (!this.plans.length) { this.root.hidden = true; return; }
      this.root.hidden = false;

      const idx = this.plans.findIndex(
        (p) => p.installments_count === this.wanted && !p.deferred_days && !p.deferred_months
      );
      this.index = idx === -1 ? 0 : idx;
      this.render();
      this.startRotation();
    }

    render() {
      this.chips.innerHTML = '';
      this.plans.forEach((plan, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kbs-alma__chip';
        b.setAttribute('role', 'option');
        b.dataset.i = i;
        b.textContent = this.label(plan);
        b.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
        b.setAttribute('aria-label', (this.t.ariaPlan || '%P%').replace('%P%', this.label(plan)));
        this.chips.appendChild(b);
      });
        this.info.textContent = this.line(this.plans[this.index]);
        if (this.more) this.more.hidden = false;
    }

    select(i, lock) {
      if (i < 0 || i >= this.plans.length) return;
      this.index = i;
      if (lock) { this.locked = true; this.stopRotation(); }
      Array.prototype.forEach.call(this.chips.children, (c, n) =>
        c.setAttribute('aria-selected', n === i ? 'true' : 'false')
      );
        this.info.textContent = this.line(this.plans[i]);
    }

    startRotation() {
      if (!this.rotate || this.locked || this.plans.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let steps = 0;
      const tick = () => {
        if (this.locked || steps >= this.plans.length) return;
        steps += 1;
        this.select((this.index + 1) % this.plans.length, false);
        this.timer = setTimeout(tick, this.rotateDelay);
      };
      this.timer = setTimeout(tick, this.rotateDelay);
    }

    stopRotation() { clearTimeout(this.timer); }

    mountBuy() {
      if (!this.quick || !this.t.buy) return;
        const modal = document.querySelector('#alma-widget-modal-main-container');
      if (!modal) return;
      const box = modal.querySelector('.alma-eligibility-modal-right-side') ||
                  modal.querySelector('[data-testid="modal-container"]');
      if (!box) return;
        let btn = box.querySelector('.kbs-alma__buy');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kbs-alma__buy kbs-alma__buy--modal';
        btn.addEventListener('click', () => this.quickCheckout());
        box.appendChild(btn);
      } else if (btn.parentElement !== box || btn !== box.lastElementChild) {
        box.appendChild(btn);
      }
        const active = modal.querySelector('.alma-eligibility-modal-active-option');
      const raw = active ? active.textContent.trim() : '';
      const n = /^(\d+)x$/.test(raw) ? parseInt(raw, 10) : null;
      if (n) this.modalPlan = n;
      const next = n ? this.t.buy.replace('%C%', n) : '';
      if (btn.textContent !== next) btn.textContent = next;
      if (btn.hidden !== !n) btn.hidden = !n;
    }

    watchModal() {
      if (!this.quick) return;
      if (this.modalObs) { this.modalObs.disconnect(); this.modalObs = null; }
      let tries = 0;
      const start = () => {
        const root = document.getElementById('alma-widget-modal-main-container');
        if (!root) {
          if (++tries < 60) setTimeout(start, 100);
          return;
        }
        this.modalObs = new MutationObserver(() => this.mountBuy());
        this.modalObs.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-pressed']
        });
        this.mountBuy();
      };
      start();
    }

    async quickCheckout() {
    if (!this.quick) return;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const form = document.querySelector('form[action*="/cart/add"]');
      const idEl = form && form.querySelector('[name="id"]');
      const id = new URLSearchParams(location.search).get('variant') || (idEl && idEl.value);
      if (!id) { if (form) form.submit(); return; }
      const qtyEl = form && form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        const count = this.modalPlan ||
        (this.plans[this.index] && this.plans[this.index].installments_count);
      const btn = document.querySelector('.kbs-alma__buy--modal');
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
        if (!res.ok) throw new Error('add failed');
        if (count) {
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Alma Ratenplan': count + 'x' } })
          });
        }
        window.location.href = root + 'checkout';
      } catch (e) {
        if (btn) btn.disabled = false;
        if (form) form.submit();
      }
    }

    syncModal(label) {
      let tries = 0;
      const tick = () => {
        const btns = document.querySelectorAll(MODAL_BTNS);
        if (btns.length) {
          const hit = Array.prototype.find.call(btns, (b) => b.textContent.trim() === label);
          if (hit && hit.getAttribute('aria-pressed') !== 'true') hit.click();
          return;
        }
        if (++tries < 50) setTimeout(tick, 100);
      };
      setTimeout(tick, 120);
    }

    openModal() {
      if (!this.modal) return;
      const target = '#' + this.root.dataset.modalTarget;
      const short = (this.root.dataset.locale || 'en').slice(0, 2);
      const locale = SDK_LOCALES.indexOf(short) === -1 ? 'en' : short;
      const want = this.plans[this.index] ? this.label(this.plans[this.index]) : null;
      loadSdk().then(() => {
        window.Alma.Widgets.initialize(this.merchant, window.Alma.ApiMode.LIVE)
          .add(window.Alma.Widgets.Modal, {
            container: target,
            purchaseAmount: this.current,
            locale: locale,
            cards: ['visa', 'mastercard', 'cb', 'amex'],
            customerBillingCountry: this.country,
            // Nur die im Land erlaubten Plaene (kbs-alma-config). Betragsgrenzen prueft die API selbst.
            plans: this.allowed.map((n) => ({
              installmentsCount: n,
              deferredDays: 0,
              deferredMonths: 0,
              minAmount: 0,
              maxAmount: 100000000
            }))
          })
          .open();
        if (want) this.syncModal(want);
        this.watchModal();
      }).catch(() => {});
    }

    bind() {
      const canHover =
        !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

      this.chips.addEventListener('click', (e) => {
        const chip = e.target.closest('.kbs-alma__chip');
        if (!chip) return;
        const i = parseInt(chip.dataset.i, 10);
        const wasActive = i === this.index;
        this.select(i, true);
        if (canHover || !this.twoTap || wasActive) this.openModal();
      });
      if (canHover) {
        this.chips.addEventListener('mouseover', (e) => {
          const chip = e.target.closest('.kbs-alma__chip');
          if (chip) this.select(parseInt(chip.dataset.i, 10), true);
        });
      }
        if (this.more) this.more.addEventListener('click', () => this.openModal());
      document.addEventListener('click', (e) => {
        if (!this.quick || !e.target.closest) return;
        if (e.target.closest('.alma-eligibility-modal-eligibility-options')) {
          setTimeout(() => this.mountBuy(), 60);
        }
      });

      const schedule = () => {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          if (this.amount() !== this.current) this.refresh();
        }, 200);
      };

      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) schedule();
      });
      document.addEventListener('input', (e) => {
        if (e.target.name === 'quantity') schedule();
      });

      let href = location.href;
      new MutationObserver(() => {
        if (location.href !== href) { href = location.href; schedule(); }
      }).observe(document, { subtree: true, childList: true });
    }
  }

  const boot = () => {
    document.querySelectorAll('[data-kbs-alma]').forEach((el) => {
      if (el.__kbsAlma) return;
      el.__kbsAlma = new KbsAlma(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();